import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@uirouter/angular';
import { SelectLineProductsParams } from '../select-line-products/select-line-products.component';

@Component({
    selector: 'tt-select-line-model',
    templateUrl: './select-line-model.component.html',
    styleUrls: ['./select-line-model.component.css'],
})
export class SelectLineModelComponent implements OnChanges {
    @Input()
    params?: SelectLineModelParams;

    get?: SelectLineModelGet;

    models: Item[] = [];

    @Output()
    getLoaded = new EventEmitter<SelectLineModelGet>();

    @Output()
    submit = new EventEmitter<SelectLineProductsParams>();

    constructor(private datatask: DataTaskService, private state: StateService) {}

    public onItemClicked(event: Item) {
        this.submit.emit(this.getParams({ state: event.item_state, params: event.item_parms }) as unknown as SelectLineProductsParams);
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getSelectLineModel(this.params);
            this.getLoaded.emit(this.get);
        }
    }

    private async loadModels() {
        if (!!this.get) {
            this.models = await this.getModels(this.get);
        }
    }

    private async getSelectLineModel(params: SelectLineModelParams) {
        return (await this.datatask.Post(1096, params))[0];
    }

    private async getModels(params: SelectLineModelGet) {
        return this.datatask.Post(1097, params);
    }

    private getParams(data: any) {
        const params: { [key: string]: string } = {};

        const values = data.params.split('/');

        const paramsKeys =
            this.state
                .get(data.state)
                .url?.split('/')
                .filter((part) => part.startsWith(':'))
                .map((part) => part.replace(':', '')) ?? [];

        for (let i = 0; i < paramsKeys.length; i++) {
            params[paramsKeys[i]] = values[i];
        }

        return params;
    }

    private async init() {
        await this.loadGet();
        this.loadModels();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}

export interface SelectLineModelParams {
    argtype: 'orderline' | 'purchline';
    headno: `${number}` | number;
    lineno: `${number}` | number;
}

export interface SelectLineModelGet {
    argtype: 'orderline' | 'purchline';
    headno: `${number}` | number;
    lineno: `${number}` | number;
    filtervalue: string;
    webpage_heading: string;
    show_setting: '1' | '0';
}
